import * as React from 'react';
import * as classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import { IAppOnlyStore } from '../../stores';
import { PageBar, PortalSearchBarField } from '../../components/layout';
import { Button, EButtonType } from '../../components/action';
import { action, observable } from 'mobx';
import { Tooltip } from '../../components/popup';
import { LoadingSpinner } from '../../components/indicator';
import { Pagination } from '../../components/pagination';
import { UsersListPageBar, UsersListUserRow, UserModal } from '.';
import { EUserTypeFilter, EUserStatusFiler } from '../../../../common/interfaces/users';
import AnimateHeight from 'react-animate-height';

// Styles
const s = require('./UsersList.css');
const searchIcon = require('./../../assets/search-icon.svg');

// Component
@inject('store')
@observer
export class UsersList extends React.Component<IAppOnlyStore, {}> {
    constructor(props) {
        super(props);

        this.props.store.users.fetchUsers();
    }

    render() {
        const { users } = this.props.store;

        return (
            <UsersListPageBar>
                <AnimateHeight height={users.loading ? 'auto' : 0}>
                    <LoadingSpinner active={users.loading} />
                </AnimateHeight>

                {(users.loading === false &&
                    users.users.length > 0 && (
                        <div className={s.usersList}>
                            <table>
                                <thead>
                                    <tr>
                                        <th className="text-align-left">ID</th>
                                        <th className="text-align-left">Username</th>
                                        <th className="text-align-left">Full name</th>
                                        <th className="text-align-right">Type</th>
                                        <th className="text-align-right">Last login</th>
                                        <th className="text-align-right">Profile status</th>
                                        <th className={classNames('text-align-right', s.actionsHeader)}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {users.users.map(user => (
                                        <UsersListUserRow key={user.id} user={user} onUserEdit={this.handleOpenUserModal} />
                                    ))}
                                </tbody>
                            </table>

                            <br />

                            <Pagination
                                onPageChange={this.handleUsersPageChange}
                                currentPage={users.usersPage}
                                countPerPage={users.usersPerPage}
                                countTotal={users.usersTotal}
                            />
                        </div>
                    )) ||
                    (users.loading === false &&
                        users.users.length <= 0 && <p className={s.noResults}>No users have been found</p>)}

                <UserModal />
            </UsersListPageBar>
        );
    }

    @action
    private handleOpenUserModal = (userId: number) => {
        this.props.store.users.openUserModal(userId);
    };

    @action
    private handleUsersPageChange = (newPage: number) => {
        this.props.store.users.changeUsersPage(newPage);
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/admin/UsersList.tsx